var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerSettingsNew02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70822 8.25129V2.28174H8.67247V8.25129H7.70822ZM8.19034 12.9262C7.43869 12.9262 6.73156 12.7872 6.06893 12.5091C5.4063 12.231 4.8269 11.8514 4.33074 11.3703C3.8346 10.8892 3.44312 10.3274 3.15631 9.68493C2.86948 9.04244 2.72607 8.35678 2.72607 7.62797C2.72607 6.84082 2.89668 6.09742 3.2379 5.39777C3.57911 4.69813 4.05465 4.09418 4.66453 3.58593L5.33582 4.23682C4.81741 4.64838 4.41356 5.15023 4.12427 5.7424C3.83499 6.33456 3.69034 6.96308 3.69034 7.62797C3.69034 8.83307 4.12963 9.86156 5.0082 10.7134C5.88677 11.5653 6.94749 11.9913 8.19034 11.9913C9.44392 11.9913 10.5073 11.5653 11.3805 10.7134C12.2537 9.86156 12.6903 8.83307 12.6903 7.62797C12.6903 6.96308 12.5484 6.33456 12.2645 5.7424C11.9805 5.15023 11.574 4.64838 11.0449 4.23682L11.7162 3.58593C12.3302 4.09418 12.8067 4.69813 13.1459 5.39777C13.485 6.09742 13.6546 6.84082 13.6546 7.62797C13.6546 8.35678 13.5112 9.04244 13.2244 9.68493C12.9376 10.3274 12.5477 10.8892 12.0549 11.3703C11.562 11.8514 10.9843 12.231 10.3217 12.5091C9.65902 12.7872 8.94858 12.9262 8.19034 12.9262Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSettingsNew02);
export default __webpack_public_path__ + "static/media/power_settings_new02.4ad120646bb740b93b33a83d95e8b446.svg";
export { ForwardRef as ReactComponent };